/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataSurveyShape
 */
export interface DataSurveyShape {
    /**
     * 
     * @type {DataSurveyShapeTypeEnum}
     * @memberof DataSurveyShape
     */
    type?: DataSurveyShapeTypeEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof DataSurveyShape
     */
    coordinates?: Array<Array<Array<number>>>;
}


/**
 * @export
 */
export const DataSurveyShapeTypeEnum = {
    Polygon: 'Polygon'
} as const;
export type DataSurveyShapeTypeEnum = typeof DataSurveyShapeTypeEnum[keyof typeof DataSurveyShapeTypeEnum];


/**
 * Check if a given object implements the DataSurveyShape interface.
 */
export function instanceOfDataSurveyShape(value: object): value is DataSurveyShape {
    return true;
}

export function DataSurveyShapeFromJSON(json: any): DataSurveyShape {
    return DataSurveyShapeFromJSONTyped(json, false);
}

export function DataSurveyShapeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSurveyShape {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
    };
}

export function DataSurveyShapeToJSON(json: any): DataSurveyShape {
    return DataSurveyShapeToJSONTyped(json, false);
}

export function DataSurveyShapeToJSONTyped(value?: DataSurveyShape | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

